import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PaymentConfirmation from "../pages/payment-confirmation/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/confirmacao-pagamento",
    element: <PaymentConfirmation />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;